module.exports = __webpack_public_path__ + "static/media/depart-home.c8a9ba42.svg";